import { App as CapApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { initClientErrorLogger } from "./error-logger.ts";
import { initSentry } from "./sentry.ts";
import "./styles/index.css";

initSentry();
initClientErrorLogger();

// Permet de tester onerror() de error-logger
// setTimeout(() => {
//   // vrai test d'erreur JS
//   (window as any).qwerty();
// }, 2000);

const setupStatusBar = async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      await StatusBar.hide();
      await StatusBar.setStyle({ style: Style.Dark });
      // await StatusBar.setBackgroundColor({ color: "#000000" });
      // await StatusBar.setOverlaysWebView({ overlay: true });
    } catch (err) {
      console.warn("StatusBar error:", err);
    }
  }
};

setupStatusBar();

// CapApp.addListener("appUrlOpen", ({ url }) => {
//   // Exemple: https://example.com/reset-password?token=123
//   console.log("appUrlOpen ### ", url);
//   if (url.includes(routeList.resetPassword)) {
//     // const urlObject = new URL(url);
//     // const token = urlObject.searchParams.get("token");

//     // On stocke le token dans un store ou navigate directement :
//     // window.location.replace(`/reset-password?token=${token}`);
//     window.location.replace(`/reset-password`);
//   }
// });

CapApp.addListener("appUrlOpen", ({ url }) => {
  console.log("appUrlOpen ### ", url);

  window.dispatchEvent(new CustomEvent("app-url-open", { detail: url }));
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
